import * as React from 'react'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/icon.css'
export const CategoryLinkIcon = () => (
  <i className='small double angle down icon' />
)
export const ExternalLinkIcon = () => <i className='small external link icon' />
